var map = {
	"./m/SCALE_Screen1.png": 504,
	"./m/SCALE_Screen2.png": 505,
	"./m/SCALE_Screen3.png": 506,
	"./m/introscr.jpg": 507,
	"./m/scale1.png": 508,
	"./m/scale2.png": 509,
	"./m/scale3.png": 510,
	"./m/scale4.png": 511,
	"./m/scale5.png": 512,
	"./o/SCALE.gif": 513,
	"./o/SCALE_Screen1.png": 514,
	"./o/SCALE_Screen2.png": 515,
	"./o/SCALE_Screen3.png": 516,
	"./o/introscr.jpg": 517,
	"./o/scale1.png": 518,
	"./o/scale2.png": 519,
	"./o/scale3.png": 520,
	"./o/scale4.png": 521,
	"./o/scale5.png": 522,
	"./o/zoom.png": 523,
	"./s/introscr.jpg": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 503;